import Sdata from '@/database/sdata'

let g_entity = 'member_machine_close'
let g_url    = 'studio/machineclose'
let g_pkey   = ['uid','machine']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Booking_close extends Sdata
{
  static entity = g_entity
  static url    = g_url
  static pkey   = g_pkey
}